module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("1. The Bridegroom Cousin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Touch My Tooth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fear of Mosquitoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Wounding Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Lingering Finish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. What the Soldier Made")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Big Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Rippling Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Wild Thing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Trump Shall Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. And That’s Okay!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Raisin Bombshell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Therapeutic Value of Lavender")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya",
    attrs: {
      "id": "rapp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: A Mennonite History Primer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#bm3lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet Rhoda Janzen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#bm3lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Writing: Mennonite in a Little Black Dress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#bm3lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A conversation with Rhoda Janzen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#bm3lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shame-Based Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#bm3lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions for Discussion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter04#backmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Group Gold")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0